<template>
  <v-container
    id="profile-change-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$users"
      icon-small
      color="accent"
      :title="$t('users')"
    >
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="$search"
          class="ml-auto"
          hide-details
          :label="$t('search_records')"
          single-line
          style="max-width: 400px;"
        />
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
        >
          <template v-slot:item.avatar="{item}">
            <v-img
              v-if="item.avatar"
              :src="'data:image/jpeg;base64,' + item.avatar.thumbnail"
              width="50"
              height="50"
            />
          </template>
          <template #item.actions="{item}">
            <v-btn
              class="px-0 ml-1"
              elevation="0"
              min-width="0"
              small
              text
              @click="change(item)"
            >
              <v-icon>mdi-key</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call } from 'vuex-pathify'

  export default {
    name: 'Users',
    data () {
      return {
        items: [],
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        options: {},
        search: '',
        total: 0,
        timer: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      headers () {
        return [
          {
            align: 'start',
            value: 'avatar',
            sortable: false,
          },
          {
            text: this.$t('fields.name'),
            sortable: true,
            value: 'name',
          },
          {
            text: this.$t('fields.mobile'),
            sortable: false,
            value: 'mobile',
          },
          {
            text: this.$t('fields.email'),
            sortable: false,
            value: 'email',
          },
          {
            text: this.$t('fields.address'),
            sortable: false,
            value: 'address',
          },
          {
            text: this.$t('actions'),
            sortable: false,
            value: 'actions',
            align: 'right',
            width: '200px',
          },
        ]
      },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    created () {
    },
    mounted () {
      // this.load()
    },
    methods: {
      getList: call('user/search_dev'),
      change: call('auth/change'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
    },
  }
</script>
